module.exports = __webpack_public_path__ + "img/TN.0142c816.png";